import type { ReactNode } from "react";

type CalloutVariant = "heads-up" | "in-practice" | "spec" | "tip";

const VARIANT_LABEL: Record<CalloutVariant, string> = {
  "heads-up": "Heads up",
  "in-practice": "In practice",
  spec: "Spec note",
  tip: "Tip",
};

/** Inline pull-out used to break up dense guide paragraphs. Pick a variant
 *  by purpose: `heads-up` for gotchas, `in-practice` for real-world advice,
 *  `spec` for "the standard actually says…" sidenotes, `tip` for shortcuts.
 *
 *  Renders as a <figure> so it can sit directly inside #mv-content; the
 *  label is its <figcaption> and the variant colours come from styles.css.
 *  Pass paragraphs (<p>) or inline text as children. */
export function Callout({
  variant = "in-practice",
  title,
  children,
}: {
  variant?: CalloutVariant;
  /** Optional override for the variant's default label. */
  title?: string;
  children: ReactNode;
}) {
  return (
    <figure className={`callout callout-${variant}`}>
      <figcaption>{title ?? VARIANT_LABEL[variant]}</figcaption>
      {children}
    </figure>
  );
}
